





































import Vue from "vue";
import { AttachmentGet, Controllers, ProblemResult } from "@infoland/iprova-api";
import Shared from "./../shared";
import storeHelper from "@/store/store-helper";
import { SnackBarTimeout } from "@/enums";
export default Vue.extend({
    name: "Upload",
    props: {
        value: Array as () => any[],
        label: String,
        maxfileSize: Number,
        id: String,
        readOnly: Boolean
    },
    components: {},
    data: () => ({
        attachments: [] as AttachmentGet[],
        filesUploading: false,
        allowedExtensions: undefined as string[]
    }),
    watch: {
        value: {
            immediate: true,
            handler: function (newValue) {
                this.attachments = [].concat(this.value);
            }
        }
    },
    computed: {
        fileUploadId(): string {
            return "infolandUploadFileUpload" + this.id;
        }
    },
    async created() {
        this.allowedExtensions = await storeHelper.settingsStore.getSettingAsync<string[]>("allowed_attachment_extensions");
    },
    methods: {
        hasValidExtension(file_name: string): boolean {
            const extension: string = "." + file_name.split(".").pop().toLowerCase();
            if (this.allowedExtensions.includes(extension)) return true;
            else return false;
        },
        async onFileInputChange(event: any) {
            const allowedExtensions: string = this.allowedExtensions.join(", ");
            const files = event.type == "drop" ? event.dataTransfer.files : event.target.files;
            for (let index = 0; index < files.length; index++) {
                this.filesUploading = true;
                const fileReader = new FileReader();
                const f: File = files[index];
                if (!this.hasValidExtension(f.name)) {
                    storeHelper.siteStore.setSnackBarMessageLookup(
                        this.$t("handleTodo.errorType.invalidExtension", {
                            fileName: f.name,
                            allowedExtensions
                        }).toString(),
                        true,
                        SnackBarTimeout.extra_long
                    );
                    continue;
                }
                fileReader.onload = async (e: ProgressEvent) => {
                    let data: string = (e.target as any).result ? (e.target as any).result : ""; // IE11 fix (should be (e.target as any).result)
                    let index: number = data.indexOf(";base64,");
                    this.$emit("attachment-added", { title: f.name, file: data.substring(index + 8), mime_type: f.type });
                };

                if (this.maxfileSize == undefined || this.maxfileSize == 0 || f.size < this.maxfileSize) fileReader.readAsDataURL(f);
                else this.$emit("file-too-large", f.name);
            }
            this.filesUploading = false;
        },
        focusUploadAttachement(): void {
            (this.$refs.uploadAttachement as HTMLElement).focus();
        },
        blurUploadAttachement(): void {
            (this.$refs.uploadAttachement as HTMLElement).blur();
        },
        deleteAttachment(idToDelete: string, index: number): void {
            this.$emit("delete", idToDelete, index);
        },
        downloadAttachment(url: string): void {
            window.open(url, "_blank");
        },

        downloadFile(url: string, fileName: string, mimeType: string) {
            // IE
            if ((window.navigator as any).msSaveBlob) {
                var xmlHttp = new XMLHttpRequest();
                xmlHttp.open("GET", url, true);
                xmlHttp.responseType = "blob";
                xmlHttp.onload = function () {
                    let blob = xmlHttp.response;
                    (window.navigator as any).msSaveBlob(blob, fileName);
                };
                xmlHttp.send(null);
            } else {
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                link.setAttribute("type", mimeType);
                document.body.appendChild(link);
                link.click();
            }
        },
        clickUpload() {
            const input = document.getElementById(this.fileUploadId) as HTMLElement;
            input.click();
        }
    }
});
